/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CoverageChange {
  NO_PRIOR_COVERAGE = 'NO_PRIOR_COVERAGE',
  COVERAGE_GAP = 'COVERAGE_GAP',
  WAIVED = 'WAIVED',
  PENDING_ELECTION = 'PENDING_ELECTION',
  MARKET_CHANGE_ON_TO_OFF = 'MARKET_CHANGE_ON_TO_OFF',
  MARKET_CHANGE_OFF_TO_ON = 'MARKET_CHANGE_OFF_TO_ON',
  CARRIER_CHANGE = 'CARRIER_CHANGE',
  PLAN_CHANGE = 'PLAN_CHANGE',
  PLAN_UPDATE = 'PLAN_UPDATE',
  RENEWAL_AOR_GAINED = 'RENEWAL_AOR_GAINED',
  RENEWAL = 'RENEWAL',
  UNCLASSIFIED = 'UNCLASSIFIED',
}
